/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Detail_IdleInputs */

const en_inbox_na_detail_idle = /** @type {(inputs: Inbox_Na_Detail_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a new step whenever you like`)
};

const id_inbox_na_detail_idle = /** @type {(inputs: Inbox_Na_Detail_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambah langkah baru kapan saja`)
};

/**
* | output |
* | --- |
* | "Add a new step whenever you like" |
*
* @param {Inbox_Na_Detail_IdleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_detail_idle = /** @type {((inputs?: Inbox_Na_Detail_IdleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Detail_IdleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_detail_idle(inputs)
	return en_inbox_na_detail_idle(inputs)
});